import Commissions from "./commissions";

export default Commissions;
